export const arrayRemoveElementIfExists = <T>(array: Array<T>, element: T) => {
    const arrayCopy = [...array];
    const index = arrayCopy.indexOf(element);

    if (index >= 0) {
        arrayCopy.splice(index, 1);
    }

    return arrayCopy;
}

export const arrayRemoveElementsIfExist = <T>(array: Array<T>, elements: T[]) => {
    return elements.reduce((reduced, element) => arrayRemoveElementIfExists(reduced, element), array);
}

export const arrayUnique = <T>(array: Array<T>): Array<T> => {
    return Array.from(new Set(array));
}

export const arrayUniqueObjects = <T>(array: Array<T>): Array<T> => {
    return Object.values(
        array.reduce(
            (reduced, item) => ({
                ...reduced,
                [JSON.stringify(item)]: item
            }),
            {}
        )
    );
}

export const arrayValuesBetween = <T>(startItem: T, endItem: T, array: T[]): T[] => {
    const startIndex = array.indexOf(startItem);
    const endIndex = array.indexOf(endItem);
    if (startIndex === -1 || endIndex === -1) return [];
    return array.slice(Math.min(startIndex, endIndex), Math.max(startIndex, endIndex) + 1);
};